// extracted by mini-css-extract-plugin
export default {"stepper":"GoogleSetup_stepper__CeptU","step":"GoogleSetup_step__mkODl","stepOn":"GoogleSetup_stepOn__yhnp7"};